import { Link } from "react-router-dom";

const resources = [
  {
    to: "/blog/free-elf-arrival-letter-templates-2026/",
    title: "Welcome your elf",
    description: "Find printable PDF arrival letters for your elf's first visit or return.",
  },
  {
    to: "/blog/printable-holiday-elf-letterhead-templates-guide/",
    title: "Save some blank letterhead",
    description: "Download festive stationery for handwritten notes throughout the season.",
  },
  {
    to: "/blog/elf-warning-letters-guide-templates-examples/",
    title: "Send a gentle reminder",
    description: "Use kind wording and letter examples to encourage a fresh start.",
  },
  {
    to: "/blog/holiday-elf-departure-letters-guide/",
    title: "Prepare a goodbye letter",
    description: "Plan a warm farewell that celebrates your family's Christmas memories.",
  },
  {
    to: "/blog/last-minute-holiday-elf-ideas-household-items/",
    title: "Try a quick elf idea",
    description: "Set up simple scenes with household items when you need last-minute inspiration.",
  },
  {
    to: "/elf-letter-generator/",
    title: "Create a personalized letter",
    description: "Write a note tailored to your child and elf, with three free PDF deliveries per email address.",
  },
];

interface SeasonalResourcesProps {
  embedded?: boolean;
}

const SeasonalResources = ({ embedded = false }: SeasonalResourcesProps) => (
  <section
    aria-labelledby="seasonal-resources-heading"
    className={embedded ? "mb-12" : "bg-white py-12 md:py-16"}
  >
    <div className={embedded ? "" : "container mx-auto px-4"}>
      <div className="rounded-2xl border border-elfGreen-light bg-elfGreen-light/30 p-6 md:p-10">
        <h2
          id="seasonal-resources-heading"
          className="mb-3 text-center text-3xl font-bold md:text-4xl"
        >
          Start here for Christmas
        </h2>
        <p className="mx-auto mb-8 max-w-2xl text-center text-slate-700">
          Choose an arrival day that works for your family, keep stationery handy,
          and save a goodbye note for later. These resources make each step a little easier.
        </p>
        <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {resources.map(({ to, title, description }) => (
            <li key={to}>
              <Link
                to={to}
                className="group block h-full rounded-xl border border-elfPink-light bg-white p-5 text-slate-800 transition-colors hover:bg-elfPink-light/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-700 focus-visible:ring-offset-2"
              >
                <span className="mb-2 block text-lg font-semibold group-hover:underline">
                  {title}
                </span>
                <span className="block text-sm leading-relaxed text-slate-700">
                  {description}
                </span>
              </Link>
            </li>
          ))}
        </ul>
        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm">
          <Link to="/elf-help/" className="rounded-sm font-semibold text-elfGreen-ink underline underline-offset-4 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-700 focus-visible:ring-offset-2">Forgot to move the elf? Get quick help</Link>
          <Link
            to="/blog/perfect-holiday-elf-letter-fonts/"
            className="rounded text-slate-800 underline underline-offset-4 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-700 focus-visible:ring-offset-2"
          >
            Choose an elf-letter font
          </Link>
          <Link
            to="/elf-name-generator/"
            className="rounded text-slate-800 underline underline-offset-4 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-700 focus-visible:ring-offset-2"
          >
            Find an elf name
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default SeasonalResources;
